import React from 'react'
import intl from 'react-intl-universal'
import styled from 'styled-components'
import Layout from '../components/layout'
import Article from '../components/article'

const Wrap = styled.div`
  article {
    padding-top: 0 !important;
  }
`

class DocumentExportPage extends React.PureComponent {
  render() {
    const {
      location,
      pageContext: { data },
    } = this.props
    return (
      <Wrap>
        <Layout location={location} isWithoutFooter isWithoutHeader isWithoutConcactBar>
          <h1 style={{ fontSize: '42px', fontWeight: 'bold', textAlign: 'center' }}>
            {intl.get('app.header.support')}
          </h1>
          {data.map((node, i) => {
            return (
              <>
                <h2 style={{ fontSize: '28px', fontWeight: 'bold', paddingLeft: '20px', paddingBottom: '20px' }}>{`${i +
                  1}) ${node.title}`}</h2>
                {node.menuChildren ? (
                  node.menuChildren.map((child, childIndex) => (
                    <Article
                      slug={child.slug}
                      title={`${i + 1}.${childIndex + 1}) ${child.title}`}
                      updatedAt={child.updatedAt}
                      article={child.tinyContent && child.tinyContent.tinyContent}
                    ></Article>
                  ))
                ) : (
                  <Article
                    slug={node.slug}
                    // title={node.title}
                    updatedAt={node.updatedAt}
                    article={node.tinyContent && node.tinyContent.tinyContent}
                  ></Article>
                )}
              </>
            )
          })}
        </Layout>
      </Wrap>
    )
  }
}

export default DocumentExportPage
